import { useAuthStore } from "@/store/auth-store";
import { useStudioStore } from "@/store/studio-store";
import { getHostDomain } from "./host";

/**
 * Evenements analytics du widget. Ils passent par notre API, qui les relaie a
 * PostHog (api routes/widget/public/events) : aucun traceur tiers ne tourne
 * sur le site du studio, et rien n'est garde d'un chargement a l'autre.
 */
export type WidgetEvent =
  | "widget_loaded"
  | "class_viewed"
  | "quickbook_confirmed"
  | "checkout_started"
  | "checkout_paid"
  | "waitlist_joined"
  // data-layout="videos": the same events as the studio site, with source "widget".
  | "site_video_offer_seen"
  | "site_video_bought"
  | "site_programme_viewed"
  | "site_video_resumed";

type EventProperties = Record<string, string | number | boolean | null>;

/**
 * Visiteur anonyme : un identifiant par chargement, jamais stocke.
 * crypto.randomUUID manque avant iOS 15.4 : l'appeler sans repli au chargement
 * du module ferait planter tout le widget sur ces iPhone.
 */
const loadId =
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

export function track(event: WidgetEvent, properties: EventProperties = {}) {
  const studioId = useStudioStore.getState().studioId;
  if (!studioId) return;

  const userId = useAuthStore.getState().user?.id ?? null;

  try {
    fetch("/api/widget/public/events", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "omit",
      keepalive: true,
      body: JSON.stringify({
        event,
        studioId,
        distinctId: userId ?? loadId,
        anonymous: !userId,
        hostDomain: getHostDomain(),
        properties,
      }),
    }).catch(() => {});
  } catch {
    /* l'analytics ne doit jamais casser le widget */
  }
}
